import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/functions";

// Consolidate config into a single object for clarity
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Under Jest (NODE_ENV === "test") there are no real credentials, and the
// compat SDK has no initializeTestApp. Initialize a lightweight app so modules
// importing this file load without hitting the network; tests that exercise
// firebase mock this module directly.
const firebaseApp =
  process.env.NODE_ENV === "test"
    ? firebase.initializeApp({
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "demo-test",
        apiKey: "test-api-key",
        appId: "test-app-id",
      })
    : firebase.initializeApp(firebaseConfig);

// Only initialize analytics in production
if (process.env.NODE_ENV === "production") {
  firebase.analytics();
}

const db = firebaseApp.firestore();
const storage = firebaseApp.storage();

// Local Firebase emulator wiring for E2E. Gated entirely behind
// REACT_APP_USE_FIREBASE_EMULATOR so it can never affect a sandbox/prod build
// (the flag is only ever set in .env.emulator, served on :3100). Connects the
// compat SDK instances to the local emulators and exposes a narrow,
// emulator-only hook the Playwright suite uses to authenticate via an
// Admin-SDK custom token — no login UI, no MFA, no reCAPTCHA.
if (process.env.REACT_APP_USE_FIREBASE_EMULATOR === "true") {
  const host = process.env.REACT_APP_EMULATOR_HOST || "localhost";
  const authPort = process.env.REACT_APP_EMULATOR_AUTH_PORT || "9099";
  const firestorePort = Number(
    process.env.REACT_APP_EMULATOR_FIRESTORE_PORT || "8085"
  );
  firebaseApp
    .auth()
    .useEmulator(`http://${host}:${authPort}`, { disableWarnings: true });
  db.useEmulator(host, firestorePort);
  if (typeof window !== "undefined") {
    window.__HD_E2E__ = {
      signInWithCustomToken: (token) =>
        firebaseApp.auth().signInWithCustomToken(token),
    };
  }
}

export default firebaseApp;
export { db, storage };
